<template>
  <div class="pdb-6">
    <InputFilter v-model="listFilterSearch" />
  </div>

  <div class="language-content">
    <ul class="sel-lang language-list custom-scroll">
      <li
        v-for="language in filteredLanguages"
        :key="language.code"
        :class="{
          selected: selectedLanguage?.code === language.code,
          disabled: omit === language.code,
        }"
        @click="emit('select', language)"
      >
        <p>{{ language.name }} - {{ t(`label_language_${language.code}`) }}</p>
        <IconCheck />
      </li>
      <li class="last-txt">🌎 {{ t('info_more_languages') }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import IconCheck from '@/components/jh-app/icons/IconCheck.vue';
import InputFilter from '@/components/shared/base/InputFilter.vue';
import { PAGE_LANGUAGES } from '@/static/languages';
import { Language } from '@/types/common';

const props = withDefaults(
  defineProps<{
    languages?: Language[];
    selectedLanguage?: Language | null;
    omit?: string | null;
  }>(),
  {
    languages: () => PAGE_LANGUAGES,
    selectedLanguage: null,
    omit: null,
  }
);

const emit = defineEmits<{ select: [language: Language] }>();

const { t } = useI18n();

const filteredLanguages = computed<Language[]>(() => {
  const { value } = listFilterSearch.value.find(({ isChecked }) => isChecked) || {};
  return value ? props.languages.filter(({ type }) => type.includes(value)) : props.languages;
});

const listFilterSearch = ref([
  {
    label: 'label_all',
    value: '',
    isChecked: true,
  },
  {
    label: 'label_asia',
    value: 'asia',
    isChecked: false,
  },
  {
    label: 'label_europe',
    value: 'europe',
    isChecked: false,
  },
  {
    label: 'label_america',
    value: 'america',
    isChecked: false,
  },
  {
    label: 'label_africa',
    value: 'africa',
    isChecked: false,
  },
]);
</script>

<style scoped lang="scss">
.language-content {
  width: 100%;
  overflow: hidden;
}

.language-list {
  max-height: 50vh;
  min-height: 50vh;
  width: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  li {
    padding: 1rem 0;
    border-bottom: 1px solid $color-gray-40;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.selected {
      p {
        color: var(--primary);
        font-weight: 600;
      }
      svg {
        opacity: 1;
      }
    }
    &.last-txt {
      font-size: $font-size-psmall;
      justify-content: center;
      border-bottom: 0;
    }
    svg {
      color: var(--primary);
      opacity: 0;
    }
  }
}

@media (hover: hover) and (pointer: fine) {
  li:hover {
    background: var(--surface-hover);
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
